import { Inbox } from "lucide-react";

export default function EmptyState({ icon: Icon = Inbox, title, description, action }) {
  return (
    <div className="flex flex-col items-center justify-center py-16 border border-dashed border-border rounded-lg bg-muted/20">
      <div className="h-14 w-14 rounded-full bg-secondary flex items-center justify-center">
        <Icon className="h-6 w-6 text-primary" strokeWidth={2} />
      </div>
      <p className="mt-4 font-heading text-lg font-semibold text-slate-800">{title}</p>
      {description && (
        <p className="mt-1 text-sm text-muted-foreground text-center max-w-sm">
          {description}
        </p>
      )}
      {action && <div className="mt-5">{action}</div>}
    </div>
  );
}
